<template>
  <div class="pwd">
    <div class="inputBox">
      <input class="input" type="password" placeholder="输入6位数新密码" v-model="password" maxlength="6" />
    </div>
    <div class="inputBox">
      <input class="input" type="password" placeholder="确认6位数新密码" v-model="passwordagin" maxlength="6" />
    </div>
    <!-- <div class="inputBox">
      <input class="input" type="text" placeholder="输入手机号" v-model="" />
    </div> -->

    <div class="inputBox">
      <input class="input" type="text" placeholder="输入验证码" v-model="sn" maxlength="4" />
      <input class="btn" type="button" v-model="btnValue" @click="smsCode" />
    </div>
    <input type="button" class="btn1" value="确认修改"  @click="subForSetPswd" />
  </div>
</template>

<style lang="less">
.pwd {
  .inputBox {
    display: flex;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    padding: 0 24px;
    background-color: #fff;
    border-bottom: 1Px solid #eee;
    .input {
      flex: 1;
      height: 100px;
      border: none;
      font-size: 28px;
      color: #333;
    }
    .btn {
      width: 200px;
      height: 70px;
      font-size: 26px;
      color: #fff;
      line-height: 70px;
      text-align: center;
      background-color: #e42129;
      border: none;
      -webkit-appearance:none;
    }
  }
  .btn1 {
    width: 702px;
    height: 98px;
    font-size: 32px;
    color: #fff;
    text-align: center;
    line-height: 98px;
    background: #e42129;
    border: none;
    border-radius: 10px;
    margin: 75px auto;
    display: block;
    -webkit-appearance:none;
  }
}
</style>

<script>
export default {
  data () {
    return {
      btnValue: '获取验证码',
      int: null,
      password:'',
      passwordagin:'',
      sn:''
    }
  },
  methods: {

    subForSetPswd(){
      let password = this.password
      let passwordagin = this.passwordagin
      let sn = this.sn

      let reg = /\S/

      if(!reg.test(password)) return this.$toast('密码不能为空')
      if(!reg.test(passwordagin))  return this.$toast('密码不能为空')
      if(!reg.test(sn)) return this.$toast('请输入验证码')

      if(password !== passwordagin) return this.$toast('两次输入密码不一致')
      this.$http({
        url:'subForSetPswd',
        data:{
          password,
          passwordagin,
          sn
        }
      }).then(res=>{
        this.$toast('密码修改成功')
        setTimeout(() => {
          this.$router.go(-1) 
        }, 1500);
      }).catch(err=>{
        if(err.response.status == 500){
          this.$toast('验证码输入错误')
        } 
      })
    },
    smsCode () {
      if (this.btnValue != '获取验证码') return
      let num = 60
      this.btnValue = `${num}s可重试`
      this.int = setInterval(() => {
        num--
        if (num == 0) {
          clearInterval(this.int)
          this.btnValue = '获取验证码'
          return
        }
        this.btnValue = `${num}s可重试`
      }, 1000)
      this.$http({
        url:'getMsgForSetPswd'
      }).then(res=>{
        this.$toast('短信发送成功，请注意查收')
      })
    }
  }
}
</script>
